import React, { useContext } from 'react';

import { MDText } from 'i18n-react';

import { Document, DOCUMENT_CAPTURE_RESPONSE_API_KEYS, DOCUMENT_ORDER } from '../../../DocumentCapture.helpers';
import { DocumentKindsValue } from '../../../DocumentCapture.types';
import { DocumentCaptureConfirmationProgressContext, FinanceSettlementProviderContext } from '../../../DocumentCaptureContexts';
import DocumentCaptureHeaderAndSummary from '../../../shared/DocumentCaptureHeaderAndSummary/DocumentCaptureHeaderAndSummary';
import LocalTexts from '../../UploadDocuments.texts.json';
import DocumentSummaryButtons from '../../UploadDocumentSummaryViews/DocumentSummaryButtons';
import DocumentSummaryTiles from '../../UploadDocumentSummaryViews/DocumentSummaryTiles';
import { UploadDocumentsVerification } from '../UploadDocumentsVerification/UploadDocumentsVerification';

const LocalT = new MDText(LocalTexts);

export const sortRequiredDocumentsAndFilterUndefined = (requiredDocuments: Document[]) =>
  requiredDocuments.map((document) => document.kind)
    .filter((document) => document !== undefined)
    .sort((a, b) =>
      (a ? DOCUMENT_ORDER.indexOf(a) : -1) - (b ? DOCUMENT_ORDER.indexOf(b) : -1)) as DocumentKindsValue[];

const UploadDocumentsSummary = () => {
  const { progress: { documents = [] } } = useContext(DocumentCaptureConfirmationProgressContext);
  const { isAutomatedDocumentUpload } = useContext(FinanceSettlementProviderContext);

  const requiredDocuments = documents
    .filter((document) => document[DOCUMENT_CAPTURE_RESPONSE_API_KEYS.DOCUMENTS_REQUIRED]);

  // Sort Required Documents and remove Additional Documents from list
  const requiredDocumentsList = sortRequiredDocumentsAndFilterUndefined(requiredDocuments);

  return (
    isAutomatedDocumentUpload
      ? <UploadDocumentsVerification />
      : <>
        <DocumentCaptureHeaderAndSummary
          header={LocalT.translate('pageTitle') as string}
          summary={<p>{LocalT.translate('weNeedImportantDocuments')}</p>}
        />
        <DocumentSummaryTiles documentList={requiredDocumentsList} />
        <DocumentSummaryButtons />
      </>
  );
};

export default UploadDocumentsSummary;
